export const NoosShareStorageKey = 'noos-share';
